export const INCOMING_PAYMENT_APPROVED_EVENT = 'dpgIncomingPaymentApproved';

